import { PaymentItemType } from "./enums/payment-item-type";
import { PaymentItem } from "./payment-item";

export class InvoicePaymentItem extends PaymentItem {
    invoiceNumber: string;
    invoiceDate: string;

    constructor() {
        super();
        this.itemType = PaymentItemType.Invoice;
    }
}